/** The Daily Run's words (docs/spec/03 §6): the day, its number, and the player's best of it. Pure. */

import type { Day } from '../../game/daily';
import { dailyNumber } from '../../game/daily';
import type { DailyBest } from '../../platform/scoreBook';
import type { MenuItem } from '../kit/menuModel';
import { commas, longDate, spread } from '../kit/text';

/** What the Daily Run is, in one sentence. */
export const DAILY_ABOUT = 'SUPERNOVA ON THE SAME SEED FOR EVERYONE TODAY.';

/** `DAILY RUN #12`. */
export function runTitle(day: Day): string {
  return `DAILY RUN #${dailyNumber(day)}`;
}

/** `8 OCT 2026 UTC`: the day turns over at midnight UTC, wherever the player is. */
export function dayLine(day: Day): string {
  return `${longDate(day.year, day.month, day.day)} UTC`;
}

/** Width of the best-of-today lines, in characters. */
export const BEST_COLS = 20;

/** The player's best today as label and value lines, or one line saying there is none yet. */
export function bestLines(best: DailyBest | null): string[] {
  if (!best) return ['NOT PLAYED YET'];
  return [
    spread('SCORE', commas(best.score), BEST_COLS),
    spread('STAGE', String(best.stage), BEST_COLS),
    spread('ATTEMPTS', String(best.attempts), BEST_COLS),
  ];
}

/** The screen's two choices; PLAY becomes PLAY AGAIN once the day has a run. */
export function dailyItems(best: DailyBest | null): MenuItem[] {
  return [{ id: 'play', label: best ? 'PLAY AGAIN' : 'PLAY' }, { id: 'back', label: 'BACK' }];
}
